import React from "react";
import { motion } from "framer-motion";
import CalendlyButton from "../components/CalendlyButton";

const paragraphs = [
    "Tap into exclusive opportunities through our nationwide network. We support investors and buyer’s agents alike by uncovering off-market and high-growth properties others struggle to access.",
    "Build your portfolio with our proven PS3 investment framework. Backed by data and expert mortgage partners, we help you make smart, strategic purchases that deliver results.",
    "Maximise returns with high-yield SMSF strategies. We specialise in sourcing SMSF-compatible properties with strong cash flow and long-term growth potential.",
    "As Part of our mission to make sourcing smarter, we've built PropSourcing — a powerful app that helps buyers' agents and investors discover, shortlist, and manage investment-grade properties with ease. It's your edge in a competitive market."
  ];
  

const WhyUsSection = () => {
  return (
    <section id="why" className="bg-[#f9f9f9] py-20 px-6">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-start gap-10">
        {/* Text Section */}
        <div className="w-full lg:w-3/5">
          <h2 className="text-3xl font-bold text-[#003366] mb-6 text-center md:text-left">
            Why Choose NPC
          </h2>

          <div className="space-y-6 text-[#003366] text-lg leading-relaxed">
            {paragraphs.map((text, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                className="bg-white p-5 rounded-lg shadow-sm border-l-4 border-[#fbb40b] flex gap-4"
              >
                <div className="text-[#da3e13] font-bold text-lg">{idx + 1}.</div>
                <div>{text}</div>
              </motion.div>
            ))}
          </div>

          <div className="mt-10">
            <CalendlyButton text="Book Free Consultation" />
          </div>
        </div>

        {/* Optional Image */}
        {/* <div className="w-full lg:w-2/5 hidden lg:block">
          <img
            src="/why-us.webp"
            alt="Why Choose Us"
            className="w-full rounded-lg shadow-md"
          />
        </div> */}
      </div>
    </section>
  );
};

export default WhyUsSection;
